import React from 'react';
import './valueDisplayReport.css';
import { connect } from 'react-redux';
import { t } from 'i18next';
import Loading from '../../loading/Loading';
import Tooltip from '../../toolTip/tooltip';

const { keys } = Object;

const ValueDisplayReport = ({
  title, data: {
    datapoint_details = {},
    datapoint_id = [],
    details = {

    },
    id = [

    ],
  }, width

}) => (
  <div className="value-report-container" style={{
    width: `${width}%`,
  }}
  >
    <h2 className="report-title">{t(title)}</h2>
    <hr className="horizontal-bar" />
    <div className="flex-container">
      {keys(details)
        .map((key, index) => (
          <div key={key} className="value-report">
            <div className="value-report-title flex-wrapper">
              <span>{t(key)}</span>
              <Tooltip description={details[key].reportDescription ? details[key].reportDescription.expanded_desc : ''}
                id={t(key)}
              />
            </div>

            <div id={id[index]}
                 className={`value-report-total ${(details[key].report === t('unableToFetchData') || details[key].report === t('notComputable')) ? 'unable-to-fetch-data' : ''}`}
            >
              {(details[key].report === t('unableToFetchData'))
                ? t('unableToFetchData')
                : (details[key].report === t('notComputable'))
                  ? t('notComputable')
                  : ! details[key].report ? <Loading size={20} /> : details[key].report}
            </div>

            {id[index] === 'datapoint-transactions' &&
              <div className="flex-wrapper datapoint-values">
                {keys(datapoint_details)
                  .map((key, index) => (
                    <div id={datapoint_id[index]} key={key}>{t(key)}:
                      <span className={`value-report-total ${datapoint_details[key].report === t('unableToFetchData') ? 'unable-to-fetch-data' : ''}`}>
                        {(datapoint_details[key].report === t('unableToFetchData'))
                          ? t('unableToFetchData')
                          : ! datapoint_details[key].report ? <Loading size={20} /> : datapoint_details[key].report}
                      </span>
                    </div>
                    ))}
              </div>
            }
          </div>
        ))}
    </div>
  </div>
);

export default connect()(ValueDisplayReport);
